import models from './models.js';
import pages from './pages/index.js';
import actions from './actions.js';
import messages from './messages.js';
import theme from './theme.js';

export default {
	common: { loading: '加载中…' },
	models,
	pages,
	actions,
	messages,
	theme
};
